import React, { useState, createContext, useEffect } from "react";
import axios from "../utils/Axios";

export const AuthContext = createContext();

const AuthProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [title, setTitle] = useState("all");
  const [isOpen, setIsOpen] = useState(false);
  const [userRole, setUserRole] = useState("");
  const [accessOfModules, setAccessOfModules] = useState([]);
  const [allModuleInfo, setAllModuleInfo] = useState([]);
  const [users, setUsers] = useState([]);
  const [isEdited, setIsEdited] = useState(false);
  const [loadingModule, setLoadingModule] = useState(false);
  const [childCardModules, setChildCardsModules] = useState([]);
  const [allOptions, setAllOptions] = useState([]);
  const [managerModule, setManagerModule] = useState([]);

  const fetchUsers = async () => {
    try {
      setLoadingModule(true);
      const response = await axios.get("/pbi-dashbord/fetch-pbi-users");
      const extractedData = response?.data
        .map((user) => {
          const filteredRoles = user?.userRoles?.filter((role) =>
            role?.roleName?.startsWith("pbi_")
          );

          if (filteredRoles?.length === 0) return null; 

          return filteredRoles?.map((role) => ({
            role: role?.roleName?.split("_")[1],
            username: user?.username,
            email: user?.email,
            modules: role?.modules || [],
          }));
        })
        .flat()
        .filter(Boolean);

      setUsers(extractedData);
    } catch (error) {
      console.log("Error while loading users.", error);
    } finally {
      setLoadingModule(false);
    }
  };

  const fetchModuleInfo = async () => {
    try {
      const response = await axios.get("/pbi-dashbord/getAllModules");
      setAllModuleInfo(response?.data);
    } catch (error) {
      console.log("Error while loading module info.", error);
    }
  };

  const handleUserInfo = async () => {
    const data = localStorage.getItem("User_info");
    if (data) {
      try {
        const user = JSON.parse(data);
        const result = user?.userRoles?.find((item) => item?.roleName?.startsWith("pbi_"));

        if (result) {
          const roleNamePart = result?.roleName?.split("_")[1];
          setUserRole(roleNamePart);

          const modules = Array.isArray(result.modules) ? result.modules : [];      
          setAccessOfModules([roleNamePart ? roleNamePart.toLowerCase() : "", ...modules]);
        }
      } catch (error) {
        console.error("Error parsing user data:", error);
      }
    }

    const token = localStorage.getItem("token");
    if (token) setIsAuthenticated(true);
  };

  useEffect(() => {
    handleUserInfo();
    fetchUsers();
    fetchModuleInfo();
  }, [isEdited]);

  const parentModules = allModuleInfo?.map((module) => ({
    title: module.parentModuleName,
    path: module.pathName,
    cardStatus: module.cardStatus,
  }));

  useEffect(() => {
    const result = allModuleInfo?.flatMap((item) =>
      item?.childCards?.map((child) => child?.childCardName)
    );
    const result1 = allModuleInfo?.flatMap((item) => item?.parentModuleName);
    setManagerModule(result1);
    const allOption = [...result1, ...result];
    setAllOptions(allOption);
  }, [allModuleInfo]);

  console.log("allModuleInfo", allOptions);

  return (
    <AuthContext.Provider
      value={{
        isAuthenticated,
        setIsAuthenticated,
        accessOfModules,
        title,
        setTitle,
        userRole,
        isOpen,
        isEdited,
        allModuleInfo,
        childCardModules,
        setChildCardsModules,
        setIsEdited,
        setIsOpen,
        parentModules,
        loadingModule,
        users,
        allOptions,
        managerModule,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export default AuthProvider;
